import React from "react";
import PropTypes from "prop-types";
import { kebabCase } from "lodash";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { classificationMatchesRlClassification } from "../../../../lib/enums/ThreatStatusEnum";
import { ANALYSIS_CLASSIFICATION, ANALYSIS_METHOD } from "./consts";
import { remapedUiClassificationLabel } from "../../../../utils";

const AnalysisTableResultWrapper = ({ resultData, children }) => (
  <span className="analysis-table__the-result">
    <span className={`threat threat--${kebabCase(resultData)}`} />{" "}
    {remapedUiClassificationLabel(resultData)}
    {children}
  </span>
);

AnalysisTableResultWrapper.propTypes = {
  resultData: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node
};

const AnalysisTableResult = ({
  resultData,
  showHelpMessage,
  isCloudOverride,
  analysis
}) => {
  if (!resultData) return null;

  if (
    !classificationMatchesRlClassification(resultData) &&
    resultData !== ANALYSIS_CLASSIFICATION.NO_THREATS_FOUND // TODO: remove this part after no_threats_found is added to threat_status enum
  ) {
    return (
      <span className="analysis-table__the-result u-capitalize">
        {resultData}
      </span>
    );
  }

  if (analysis !== ANALYSIS_METHOD.RL_SANDBOX.SHORT_NAME) {
    return <AnalysisTableResultWrapper resultData={resultData} />;
  }

  return (
    <AnalysisTableResultWrapper resultData={resultData}>
      {showHelpMessage && !isCloudOverride && (
        <OverlayTrigger
          overlay={
            <Tooltip id={`${new Date().getTime()}`}>
              Last successful analysis result
            </Tooltip>
          }
          placement="top"
        >
          <span className="analysis-table__result-warning-icon icon-warning-i" />
        </OverlayTrigger>
      )}
    </AnalysisTableResultWrapper>
  );
};

AnalysisTableResult.propTypes = {
  resultData: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showHelpMessage: PropTypes.bool,
  isCloudOverride: PropTypes.bool,
  analysis: PropTypes.string
};

export default AnalysisTableResult;
